module.exports = __webpack_public_path__ + "static/media/person_jumping.d501d8f1.png";